import {init} from '@/common/ConfigHelper'

const {LOGIN_URL, RETURN_URL, COMPLETION_URL} = init(null);

export const statusUCMap = {
  //未登录
  'UNAUTHENTICATED': `${LOGIN_URL}?returnUrl=${RETURN_URL}`,
  //要激活
  'USER_NOT_ACTIVE': COMPLETION_URL
}

const ERR_CODE_AUTH = 402;

export function getUCRedirect(response) {
  if (response.status !== ERR_CODE_AUTH) return;
  
  const errBody = response.error || (response.body && response.body.error);
  if (!errBody) return;
  
  const {code, status} = errBody;
  if (code !== ERR_CODE_AUTH) return;
  
  return statusUCMap.hasOwnProperty(status) 
    ? statusUCMap[status]
    : null;
}

export function redirectToUC(path=statusUCMap['UNAUTHENTICATED']) {
  window.open(path, '_top');
}


// WEBPACK FOOTER //
// ./src/axiosHandler/uc.js